import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  HostListener,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { Subject, Observable, Subscription, BehaviorSubject } from "rxjs";
import * as _ from "underscore";
import { RootStoreState } from "src/app/root-store";
import { takeUntil } from "rxjs/operators";

import { ActivatedRoute, Router } from "@angular/router";
import {
  getQuote,
  getQuoteError,
  getQuoteLoading,
  updateQuoteError,
  updateQuoteLoading,
  updateQuoteSuccess,
} from "src/app/root-store/kwikspace-app-store/selectors/quote.selector";
import { getCurrentUser } from "src/app/root-store/main-app-store/selectors/auth.selector";
import { Customer } from "src/app/models/Customer.model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  ClearQuoteList,
  EmailPurchaseQuote,
  GetQuote,
  UpdateQuote,
} from "src/app/root-store/kwikspace-app-store/actions/quote.action";
import { AppRoutes } from "src/app/shared/endpoints.enum";
import { TanToastrService } from "src/app/services/toastr.service";
import {
  getCreatedLineItemConfigs,
  getCreatedLineItemsSuccess,
  getCreatedPurchaseLineItems,
  getCreatedPurchaseLineItemsError,
  getCreatedPurchaseLineItemsLoading,
  getFpProjectCategoryError,
  getFpProjectCategoryList,
  getFpProjectCategoryListLoading,
  getFpProjectCategorySizeError,
  getFpProjectCategorySizeLoading,
  getFpProjectExtrasList,
  getFpProjectExtrasListError,
  getFpProjectExtrasListLoading,
  getFpProjectList,
  getFpProjectListError,
  getFpProjectListLoading,
  getFpProjectPriceList,
  getFpProjectPriceListError,
  getFpProjectPriceListLoading,
  getFpProjectSizeList,
  getFpProjectSizeListError,
  getFpProjectSizeListLoading,
  getFpProjectSubCategoryList,
  getFpProjectSubCategoryListError,
  getFpProjectSubCategoryListLoading,
  updatePurchaseLineItemError,
  updatePurchaseLineItemLoading,
  updatePurchaseLineItemSuccess,
} from "src/app/root-store/kwikspace-app-store/selectors/purchase.selector";
import {
  ClearPurchaseLineItem,
  ClearPurchaseLineItemConfig,
  CreatePurchaseLineItem,
  CreatePurchaseLineItemConfig,
  GetFpProjectCategory,
  GetFpProjectExtras,
  GetFpProjectLists,
  GetFpProjectPriceLists,
  GetFpProjectSize,
  GetFpProjectSubCategory,
  UpdatePurchaseLineItem,
  ClearPurchaseUpdate,
} from "src/app/root-store/kwikspace-app-store/actions/purchase.action";
import { ModalComponent } from "src/app/core/components/modal/modal.component";

import { Quote } from "src/app/models/Quote.model";
import { PurchaseSize } from "src/app/models/PurchaseSize.model";
import { KwikspaceService } from "src/app/services/kwikspace.service";
import { StaticDataService } from "src/app/services/static-data.service";
import { FpProjectCategory } from "src/app/models/FpProjectCategory.model";
import { FpProjectSubCategory } from "src/app/models/FpProjectSubCategory.model";
import { FpProjectSize } from "src/app/models/FpProjectSize.model";
import { FpProjectExtra } from "src/app/models/FpProjectExtra.model";
import { FloorplannerProject } from "src/app/models/Floorplanner.model";
import { getTransportLoads, getTransportPriceList } from "src/app/root-store/kwikspace-app-store/selectors/transport.selector";
import { GetTransportLoads, GetTransportPriceList } from "src/app/root-store/kwikspace-app-store/actions/transport.action";
import { getProvinces } from "src/app/root-store/kwikspace-app-store/selectors/kwikspace.selector";
import { GetProvinces } from "src/app/root-store/kwikspace-app-store/actions/kwikspace.action";
import { ClearProjectList } from "src/app/root-store/kwikspace-app-store/actions/floorplanner.action";
import {
  getProject,
  getProjectLoading,
  getProjectError,
  getProjectList
} from "src/app/root-store/kwikspace-app-store/selectors/floorplanner.selector";

@Component({
  selector: "kwikspace-edit-purchase-quote",
  templateUrl: "./edit-purchase-quote.component.html",
  styleUrls: ["./edit-purchase-quote.component.scss"],
})
export class EditPurchaseQuoteComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();
  private cancelationSubscription = new Subscription();

  @ViewChild("viewProjectImgModal", { static: false })
  viewProjectImgModal: ModalComponent;

  @ViewChild("quoteApproveModal", { static: false })
  quoteApproveModal: ModalComponent;

  @ViewChild("editQuoteStatusModal", { static: false })
  editQuoteStatusModal: ModalComponent;

  @ViewChild("addUnitModal", { static: false })
  addUnitModal: ModalComponent;

  @ViewChild("removeUnitModal", { static: false })
  removeUnitModal: ModalComponent;

  updateQuoteLoading$: Observable<any> = this.store.select(updateQuoteLoading);
  updateQuoteError$: Observable<any> = this.store.select(updateQuoteError);

  createdPurchaseLineItemsLoading$: Observable<any> = this.store.select(
    getCreatedPurchaseLineItemsLoading
  );
  createdPurchaseLineItemsError$: Observable<any> = this.store.select(
    getCreatedPurchaseLineItemsError
  );

  updatePurchaseLineItemLoading$: Observable<any> = this.store.select(
    updatePurchaseLineItemLoading
  );
  updatePurchaseLineItemError$: Observable<any> = this.store.select(
    updatePurchaseLineItemError
  );

  fpProjectCategoryLoading$: Observable<any> = this.store.select(
    getFpProjectCategoryListLoading
  );

  fpProjectCategoryError$: Observable<any> = this.store.select(
    getFpProjectCategoryError
  );

  fpProjectCategorySizeLoading$: Observable<any> = this.store.select(
    getFpProjectCategorySizeLoading
  );

  fpProjectCategorySizeError$: Observable<any> = this.store.select(
    getFpProjectCategorySizeError
  );

  fpProjectSubCategoryLoading$: Observable<any> = this.store.select(
    getFpProjectSubCategoryListLoading
  );

  fpProjectSubCategoryError$: Observable<any> = this.store.select(
    getFpProjectSubCategoryListError
  );

  fpProjectSizeLoading$: Observable<any> = this.store.select(
    getFpProjectSizeListLoading
  );

  fpProjectSizeError$: Observable<any> = this.store.select(
    getFpProjectSizeListError
  );

  fpProjectExtrasLoading$: Observable<any> = this.store.select(
    getFpProjectExtrasListLoading
  );

  fpProjectExtrasError$: Observable<any> = this.store.select(
    getFpProjectExtrasListError
  );

  fpProjectListLoading$: Observable<any> = this.store.select(
    getFpProjectListLoading
  );

  fpProjectListError$: Observable<any> = this.store.select(
    getFpProjectListError
  );

  fpProjectPriceListLoading$: Observable<any> = this.store.select(
    getFpProjectPriceListLoading
  );

  fpProjectPriceListError$: Observable<any> = this.store.select(
    getFpProjectPriceListError
  );

  fpGetProjectLoading$: Observable<any> = this.store.select(
    getProjectLoading
  );

  fpGetProjectError$: Observable<any> = this.store.select(
    getProjectError
  );

  quoteLoading$: Observable<any> = this.store.select(getQuoteLoading);
  quoteError$: Observable<any> = this.store.select(getQuoteError);

  isMobile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    window.innerWidth <= 768
  );

  @HostListener("window:resize", ["$event"])
  setIsMobile(event) {
    const isMobile = event.target.innerWidth <= 768;
    this.isMobile.next(isMobile);
  }

  customers: Customer[] = [];
  purchaseSizes: PurchaseSize[] = [];

  quote: Quote = null;
  quoteNumber: any = null;
  isSaProvince: boolean = false;
  canApprove: boolean = false;
  canUpdateStatus: boolean = false;
  isStaff: boolean = false;
  isCustomer: boolean = false;
  user: any = null;
  isAdmin: boolean = false;
  quoteId: any = null;

  provinces: any[] = [];
  buildingTypes: any[] = [];
  organizationalTypes: any[] = [];
  quoteLocations: any[] = [];
  quoteValidities: any[] = [];
  quoteStatus: any[] = [];
  selectedQuoteStatus: any = null;
  selectedModalLineItem = null;
  selectedModalLineItemExtra = null;
  displayExtras: boolean = false;
  extrasLoading: boolean = false;

  fpProjectCategories: FpProjectCategory[] = [];
  fpProjectSubCategories: FpProjectSubCategory[] = [];
  fpProjectSizes: FpProjectSize[] = [];
  fpProjectExtras: FpProjectExtra[];

  qtyEntered: boolean = false;
  showQty: boolean = false;
  projectSelected: boolean = false;
  selectedFpProject: any = null;
  selectedFpProjectId: any = null;
  selectedFpProjectCategoryId: any = null;
  selectedFpProjectCategoryName: any = null;
  selectedFpProjectSubCategoryId: any = null;
  selectedFpProjectSubCategoryName: any = null;
  selectedFpProjectSizeId: any = null;
  selectedFpProjectSizeName: any = null;
  selectedFpProjectExtraId: any = null;
  selectedFpProjectExtraName: any = null;
  projectIDSelected: number = null;

  selectedFpProjectCategory: boolean = false;
  selectedFpProjectSubCategory: boolean = false;
  selectedFpProjectSize: boolean = false;
  selectedFpProjectExtra: boolean = false;

  showProjectsTable: boolean = false;
  showFpProjectSubCategories: boolean = false;
  showSubCat: boolean = false;

  projects: FloorplannerProject[] = [];
  projectLabels: any[] = [];

  projectToView: any = null;
  projectProducts: any[] = [];

  canSave: boolean = false;
  unitQty: number = 0;

  quoteLineItem: any = {};
  quoteLineItemProducts: any[] = [];
  quoteCart: any[] = [];
  addedLineItems: any[] = [];
  addedLineItem: any = {};
  addOnsToAdd: number = 0;
  transportLoads: any[] = [];
  transportLoadError: boolean = false;
  transportPricing: any[] = [];
  transportVariations: any[] = [];
  editingTransportLoad = null;
  transportType = "load1";
  transportTwoHasPricing: boolean = false;
  transportOneHasPricing: boolean = false;

  hasTransportPricing: boolean = false;
  hasProjectPricing: boolean = false;

  purchaseForm: FormGroup;
  editQuoteForm: FormGroup;

  selectedTemplateOption: any = null;
  showTemplateOption: boolean = false;

  selectedTransportLoad = null;
  selectedTransportOption = null;
  selectedTransportJoinOption = null;
  selectedTransportExtraOption = null;
  selectedTransportLoadOne = null;
  selectedTransportLoadTwo = null;
  transportOneLoading: boolean = false;
  transportTwoLoading: boolean = false;
  addSecondTransportLoad: boolean = false;

  newUnit: boolean = false;
  editUnit: boolean = false;
  additionalUnit: boolean = false;
  selectedUnit: any = null;
  modalTitle: string = "Add Unit";
  savingUnit: boolean = false;
  recreatingExistingUnit: boolean = false;
  preloadingEditForm: boolean = false;

  constructor(
    private store: Store<RootStoreState.RootState>,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private toastrService: TanToastrService,
    private kwikspaceService: KwikspaceService,
    private staticDataService: StaticDataService
  ) { }

  ngOnInit() {
    const { params } = this.route.snapshot;
    this.quoteId = params.id;
    this.selectedTemplateOption = {};

    this.quoteStatus = this.staticDataService.getQuoteStatus();

    this.registerSelectors();
    this.getProjectCategories();

    this.editQuoteForm = this.formBuilder.group({
      quote_status: [null, []],
    });

    this.purchaseForm = this.formBuilder.group({
      project_category: [null, [Validators.required]],
      project_sub_category: [null, [Validators.required]],
      project_size: [null, [Validators.required]],
      project_extra: [null, []],
      template_option: [null, []],
      quantity: [null, [Validators.required]],
      transport_load_one: [null, [Validators.required]],
      transport_load_one_qty: [null, [Validators.required]],
      transport_load_two: [null, []],
      transport_load_two_qty: [null, []],
    });

    this.initialDispatches();
    this.store.dispatch(new GetProvinces());
  }

  initialDispatches() {
    this.store.dispatch(new ClearQuoteList());
    this.store.dispatch(new ClearPurchaseLineItem());
    this.store.dispatch(new ClearPurchaseUpdate());
    this.store.dispatch(new ClearPurchaseLineItemConfig());
    this.store.dispatch(new ClearProjectList());
    this.store.dispatch(new GetQuote(this.quoteId));
    this.savingUnit = false;
    this.recreatingExistingUnit = false;
    this.selectedUnit = null;
    this.editUnit = false;
  }

  saveProducts() {
    let addon = this.quoteLineItemProducts[0];

    this.saveProduct(addon);
  }

  saveProduct(addon) {
    let purchase_line_item = this.addedLineItem.id;

    let payload = {
      name: addon.name,
      asset: "",
      quantity: addon.qty,
      unit_price: 0,
      total_price: 0,
      purchase_line_item,
    };

    this.store.dispatch(new CreatePurchaseLineItemConfig(payload));
  }
  closeAddUnit() {
    this.addUnitModal.close();
  }

  resetUnitForm() {
    this.purchaseForm.reset();

    this.selectedFpProject = null;
    this.selectedFpProjectCategoryId = null;
    this.selectedFpProjectSubCategoryId = null;
    this.selectedFpProjectSizeId = null;
    this.selectedFpProjectExtraId = null;
    this.selectedTemplateOption = null;

    this.projectSelected = false;
    this.qtyEntered = false;
    this.addSecondTransportLoad = false;
    this.selectedFpProjectCategory = false;
    this.selectedFpProjectSubCategory = false;
    this.selectedFpProjectSize = false;
    this.showProjectsTable = false;

    this.showTemplateOption = false;
    this.newUnit = false;
    this.editUnit = false;
  }

  addUnit() {
    this.purchaseForm.reset();
    this.modalTitle = "Add Unit";
    this.newUnit = true;
    this.editUnit = false;
    this.additionalUnit =
      this.quote.lineItems && this.quote.lineItems.length > 0 ? true : false;
    this.addUnitModal.open();
  }

  getProjectCategories() {
    this.store.dispatch(new GetFpProjectCategory());
    this.getTransportLoads();
  }

  getProjectSubCategories() {
    let payload = {
      category: `?category=${this.selectedFpProjectCategoryId}`,
    };
    this.store.dispatch(new GetFpProjectSubCategory(payload));
  }

  getProjectSizes() {
    let payload = {
      category: `?category=${this.selectedFpProjectCategoryId}&sub_category=${this.selectedFpProjectSubCategoryId}`,
    };
    this.store.dispatch(new GetFpProjectSize(payload));
  }


  // getProjectExtras(labels) {
  //   this.store
  //     .select(getFpProjectExtrasList)
  //     .pipe(takeUntil(this.ngUnsubscribe))
  //     .subscribe((variations) => {
  //       if (variations) {
  //         let filteredVariations = [];
  //         // find the labels in the returned variations, and filter out options not available

  //         variations.forEach((option) => {
  //           let variationName = option.name;

  //           if (labels.includes(variationName)) {
  //             filteredVariations.push(option);
  //           }
  //         });

  //         this.fpProjectExtras = filteredVariations;
  //       }
  //     });
  //     // let payload = {
  //     //   category: `?category=${this.selectedFpProjectCategoryId}&sub_category=${this.selectedFpProjectSubCategoryId}`,
  //     // };
  //   this.store.dispatch(new GetFpProjectExtras());
  // }

  setFpProjectCategory() {
    // this.selectedFpProjectCategoryId =
    //   this.purchaseForm.value.project_category.id;
    // this.selectedFpProjectCategoryName =
    //   this.purchaseForm.value.project_category.name;
    // this.selectedFpProjectCategory = true;

    // this.selectedFpProjectSubCategoryId = null;
    // this.selectedFpProjectSubCategoryName = "";
    // this.selectedFpProjectSizeId = null;
    // this.selectedFpProjectSizeName = "";
    // this.selectedFpProjectExtraId = null;
    // this.selectedFpProjectExtraName = "";

    // this.selectedFpProjectSubCategory = false;
    // this.selectedFpProjectSize = false;
    // this.selectedFpProjectExtra = false;

    // this.getProjectSubCategories();
    // this.getProjectList();

    this.selectedFpProjectCategoryId =
      this.purchaseForm.value.project_category.id;
    this.selectedFpProjectCategoryName =
      this.purchaseForm.value.project_category.name;
    this.selectedFpProjectCategory = true;

    this.selectedFpProjectSubCategoryId = null;
    this.selectedFpProjectSubCategoryName = "";
    this.selectedFpProjectSizeId = null;
    this.selectedFpProjectSizeName = "";
    this.selectedFpProjectExtraId = null;
    this.selectedFpProjectExtraName = "";

    this.selectedFpProjectSubCategory = false;
    this.selectedFpProjectSize = false;
    this.selectedFpProjectExtra = false;
    this.displayExtras = false;

    this.showQty = false;

    this.getProjectSubCategories();
    // this.getProjectList();
  }

  setFpProjectSubCategory() {
    // this.selectedFpProjectSubCategoryId =
    //   this.purchaseForm.value.project_sub_category.id;
    // this.selectedFpProjectSubCategoryName =
    //   this.purchaseForm.value.project_sub_category.name;
    // this.selectedFpProjectSubCategory = true;

    // this.selectedFpProjectSizeId = null;
    // this.selectedFpProjectSizeName = "";
    // this.selectedFpProjectExtraId = null;
    // this.selectedFpProjectExtraName = "";

    // this.selectedFpProjectSize = false;
    // this.selectedFpProjectExtra = false;

    // this.getProjectSizes();
    // this.getProjectList();

    this.selectedFpProjectSubCategoryId =
      this.purchaseForm.value.project_sub_category.id;
    this.selectedFpProjectSubCategoryName =
      this.purchaseForm.value.project_sub_category.name;
    this.selectedFpProjectSubCategory = true;

    this.selectedFpProjectSizeId = null;
    this.selectedFpProjectSizeName = "";
    this.selectedFpProjectExtraId = null;
    this.selectedFpProjectExtraName = "";

    this.selectedFpProjectSize = false;
    this.selectedFpProjectExtra = false;

    this.showQty = false;
    this.displayExtras = false;

    this.getProjectSizes();
    // this.getProjectList();
  }

  setFpProjectSize() {
    this.selectedFpProjectSizeId = this.purchaseForm.value.project_size.id;
    this.selectedFpProjectSizeName = this.purchaseForm.value.project_size.size;
    this.selectedFpProjectSize = true;

    this.selectedFpProjectExtraId = null;
    this.selectedFpProjectExtraName = "";

    this.selectedFpProjectExtra = false;
    this.showTemplateOption = false;
    this.selectedTemplateOption = {};
    this.displayExtras = false;

    this.showQty = false;
    this.projects = [];

    this.getProjectListForVariations();
  }

  getProjectListForVariations() {
    this.extrasLoading = true;
    if (
      this.selectedFpProjectCategoryId != null &&
      this.selectedFpProjectSubCategoryId != null &&
      this.selectedFpProjectSizeId != null
    ) {
      this.store
        .select(getFpProjectList)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((projects: any) => {
          if (projects?.results?.length > 0) {
            if (this.projects.length == 0) {
              projects.results.forEach((proj) => {
                let labels = proj.labels[0].description;
                this.projectLabels.push(labels);
              });
              this.getProjectExtras();
            }
          }
        });
      let payload = {
        category: `?category=${this.selectedFpProjectCategoryName}`,
        sub_category: `&sub_category=${encodeURIComponent(
          this.selectedFpProjectSubCategoryName
        )}`,
        size: `&size=${this.selectedFpProjectSizeName}`,
      };
      this.store.dispatch(new GetFpProjectLists(payload));
    }
  }

  getProjectExtras() {
    this.store
      .select(getFpProjectExtrasList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((variations) => {
        if (variations && variations.length > 0) {
          let filteredVariations = [];
          variations.forEach((option) => {
            let variationName = option.name;
            if (this.projectLabels.includes(variationName)) {
              filteredVariations.push(option);
            }
          });
          this.fpProjectExtras = filteredVariations;
          this.extrasLoading = false;
          this.displayExtras = true;
        }
      });
    this.store.dispatch(new GetFpProjectExtras());
  }

  setFpProjectExtra() {
    // this.selectedFpProjectExtraId = this.purchaseForm.value.project_extra.id;
    // this.selectedFpProjectExtraName =
    //   this.purchaseForm.value.project_extra.name;
    // this.selectedFpProjectExtra = true;

    // this.getProjectList();

    this.selectedFpProjectExtraId = this.purchaseForm.value.project_extra.id;
    this.selectedFpProjectExtraName =
      this.purchaseForm.value.project_extra.name;
    this.selectedFpProjectExtra = true;

    this.showQty = true;

    this.getProjectList();
  }

  getProjectList() {
    this.showProjectsTable = false;

    if (
      this.selectedFpProjectCategoryId != null &&
      this.selectedFpProjectSubCategoryId != null &&
      this.selectedFpProjectSizeId != null &&
      this.selectedFpProjectExtraId != null
    ) {
      this.store
        .select(getFpProjectList)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((projects: any) => {
          if (projects?.results?.length > 0) {
            this.projects = projects.results;
            this.showProjectsTable = true;
          } else {
            this.showProjectsTable = false;
          }
        });
      let payload = {
        category: `?category=${this.selectedFpProjectCategoryName}`,
        sub_category: `&sub_category=${encodeURIComponent(this.selectedFpProjectSubCategoryName)}`,
        size: `&size=${this.selectedFpProjectSizeName}`,
        variation: `&description=${this.selectedFpProjectExtraName}`,
      };
      this.store.dispatch(new GetFpProjectLists(payload));
    }
  }

  setTemplateOption() {
    this.selectedFpProjectId = this.purchaseForm.value.template_option;
    const _id = this.projects.findIndex(
      (obj) => obj.floorplannerProjectId == this.selectedFpProjectId
    );
    this.selectedFpProject = this.projects[_id];
    this.selectedTemplateOption = this.projects[_id];

    this.showTemplateOption = true;

    this.selectItem(this.selectedFpProject);
  }

  selectItem(project: any) {
    project = {
      ...project,
      unit:
        "Unit " + (this.projects.length + 1),
      idx: this.projects.length + 1,
      mappedProducts: this.mapProducts(project.products),
      drawingNumber: "",
      size: this.selectedFpProjectSizeName,
      variation: this.selectedFpProjectExtraName,
      price: 0,
      quantity: this.unitQty,
      isTemplate: true,
      transportOne: "",
      transportTwo: "",
      transportJoin: "",
      transportExtra: "",
    };

    this.selectedFpProject = project;
    this.projectSelected = true;

    this.addItemProducts();
    this.getTemplateProjectPricing();
  }

  renameUnits() {
    this.quote.purchaseLineItems.map((lineItem, index) => {
      lineItem.unit = `Unit ${index + 1}`;

      // TODO: Update each line item with new unit title.
      // Show loader and fetch quote when done.
      this.store.dispatch(
        new UpdatePurchaseLineItem(lineItem, lineItem.id)
      );
    })
  }

  getTransportLoads() {
    this.store.dispatch(new GetTransportLoads());

    this.store
      .select(getTransportLoads)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((loads: any) => {
        if (loads && loads.length > 0) {
          this.transportLoads = loads.filter(
            (loadSize) => loadSize.available == true
          );
          this.transportLoads = loads.filter(
            (loadSize) => loadSize.hasPurchase == true
          );
        }
      });
  }

  viewItem() {
    this.projectToView = this.selectedTemplateOption;
    this.projectProducts = this.mapProducts(this.selectedTemplateOption.products);
    this.viewProjectImgModal.open();
  }

  addAnotherTruck() {
    this.addSecondTransportLoad = true;
  }

  setSelectedTransportLoadOne() {
    this.selectedTransportLoadOne = {
      load: this.purchaseForm.value.transport_load_one,
      quantity: this.purchaseForm.value.transport_load_one_qty,
      results: null,
    };
    if (
      this.selectedTransportLoadOne.load &&
      this.selectedTransportLoadOne.quantity
    ) {
      this.transportOneLoading = true;
      this.transportOneHasPricing = false;
      this.transportType = "load1";
      this.editingTransportLoad = this.selectedTransportLoadOne;
      this.calculateTransportPricing();
    }
  }

  setSelectedTransportLoadTwo() {
    this.selectedTransportLoadTwo = {
      load: this.purchaseForm.value.transport_load_two,
      quantity: this.purchaseForm.value.transport_load_two_qty,
      results: null,
    };
    if (
      this.selectedTransportLoadTwo.load &&
      this.selectedTransportLoadTwo.quantity
    ) {
      this.transportTwoLoading = true;
      this.transportTwoHasPricing = false;
      this.transportType = "load2";
      this.editingTransportLoad = this.selectedTransportLoadTwo;
      this.calculateTransportPricing();
    }
  }

  calculateTransportPricing() {
    const shipping_area = this.quote.shippingArea ? this.quote.shippingArea.id : '';
    const params = `?load_size=${this.editingTransportLoad.load}&transport_location=${shipping_area}`;
    this.store.dispatch(new GetTransportPriceList(params));
  }

  filterTransportList(type, transportResults, load) {
    let filteredArray = [];
    transportResults.forEach((price) => {
      if (price.priceType.name == "Both" || price.priceType.name == "Rentals") {
        if (
          price.transportCharge.name == "Transport" ||
          price.transportCharge.name == "Delivery and Collection"
        ) {
          filteredArray.push(price);
        }
      }
    });
    if (type === "load1") {
      this.selectedTransportLoadOne.results = filteredArray[0];

      const transport = {
        id: this.selectedTransportLoadOne.results.id,
        transport: this.selectedTransportLoadOne.results,
        quantity: load.quantity,
      };

      this.quoteLineItem.transportOne = transport;
      this.transportOneLoading = false;
      this.transportOneHasPricing = true;
    } else if (type === "load2") {
      this.selectedTransportLoadTwo.results = filteredArray[0];

      const transport = {
        id: this.selectedTransportLoadTwo.results.id,
        transport: this.selectedTransportLoadTwo.results,
        quantity: load.quantity,
      };

      this.quoteLineItem.transportTwo = transport;
      this.transportTwoLoading = false;
      this.transportTwoHasPricing = true;
    }
  }

  hasJoining() {
    let join = false;

    const size = this.selectedFpProject.size;

    let min = size.split("m x")[0];
    min = parseInt(min);
    join = min > 3 ? true : false;

    return join;
  }

  calculateLoadSize() {
    let match;
    const size = this.selectedFpProject.size;

    let min = size.split("m x")[0];
    let max = size.split("x")[1];
    max = max.replace("m", "");
    min = parseInt(min);
    max = parseInt(max);

    // look for an exact match
    match = this.getPerfectMatch(min, max);

    if (match != null) {
      this.selectedTransportLoad = match;

      return true;
    } else {
      // no exact match found, look for closest match
      match = this.findClosestMatch(min, max);
      if (match != null) {
        this.selectedTransportLoad = match;

        return true;
      } else {
        // no matches found, select load size manually
        this.transportLoadError = true;

        return false;
      }
    }
  }

  getPerfectMatch(unitWidth, unitLength) {
    let _id = null;

    for (let i = 0; i < this.transportLoads.length; i++) {
      let loadSize = this.transportLoads[i].size;

      let length = loadSize.split("m x")[0].replace(/\s/g, "");
      let width = loadSize.split("x")[1].replace(/\s/g, "").charAt(0);
      length = parseInt(length);
      width = parseInt(width);

      if (unitWidth == width && unitLength == length) {
        _id = this.transportLoads[i].id;
        break;
      }
    }

    return _id;
  }

  findClosestMatch(unitWidth, unitLength) {
    let _id = null;
    let matchedItems = [];

    for (let i = 0; i < this.transportLoads.length; i++) {
      let loadSize = this.transportLoads[i].size;

      let length = loadSize.split("m x")[0].replace(/\s/g, "");
      let width = loadSize.split("x")[1].replace(/\s/g, "").charAt(0);
      length = parseInt(length);
      width = parseInt(width);

      if (unitLength <= length && unitWidth <= width) {
        matchedItems.push(this.transportLoads[i]);
      }
    }

    if (matchedItems.length > 0) {
      matchedItems.sort((a, b) => (a.size > b.size ? 1 : -1));
      _id = matchedItems[0].id;
    }

    return _id;
  }

  getOptionalTransportFee(transportChargeList) {
    let count = 0;
    let id = null;
    const projectCharge = this.selectedFpProject.variation.toLowerCase();

    let charge = projectCharge.search(",");

    if (charge == -1) {
      // there is only one charge
      if (projectCharge != "standard") {
        id = this.transportVariations.findIndex(
          (obj) => obj.name.toLowerCase() == projectCharge
        );
      }
    } else {
      // there is more than one charge
      transportChargeList.forEach((name) => {
        const transportCharge = name.toLowerCase();
        count =
          transportCharge.search(projectCharge) != -1 ? (count += 1) : count;
      });

      let _id = this.transportVariations.findIndex((obj) => obj.id == 1);
    }

    return id;
  }

  mapProducts(products) {
    let mappedProducts = [];

    products.forEach((product) => {
      let productAdded = mappedProducts.some((el) => el.sku === product.sku);
      if (productAdded) {
        const idx = mappedProducts.findIndex((x) => x.sku === product.sku);
        mappedProducts[idx].qty += 1;
      } else {
        let _product = { ...product, qty: 1 };
        mappedProducts.push(_product);
      }
    });

    return mappedProducts;
  }

  addItemProducts() {
    const products = this.selectedFpProject.mappedProducts;

    this.quoteLineItemProducts = [];
    products.forEach((product, index) => {
      let _product = {
        ...product,
        added_name:
          this.quoteNumber + "," + this.selectedFpProject.unit + "," + index,
        line_item: this.selectedFpProject.idx,
      };
      this.quoteLineItemProducts.push(_product);
    });
  }

  getTemplateProjectPricing() {
    const payload = {
      category: `?category=${this.selectedFpProjectCategoryId}`,
      sub_category: `&sub_category=${this.selectedFpProjectSubCategoryId}`,
      size: `&size=${this.selectedFpProjectSizeId}`,
      variation: `&charge_variation=${this.selectedFpProjectExtraId}`,
    };

    this.store.dispatch(new GetFpProjectPriceLists(payload));
  }

  addProjectPrice(projectPrice) {
    let price = 0;

    if (this.quote && this.quote.shipping) {
      const _id = this.provinces.findIndex(
        (obj) => obj.id == this.quote.shippingProvince.id
      );

      const province = this.provinces[_id].name;

      price =
        province != "Western Cape"
          ? projectPrice.standardPrice
          : projectPrice.cptPrice;
    } else {
      price = projectPrice.cptPrice;
    }

    return price;
  }

  setUnitQty() {
    this.unitQty =
      this.purchaseForm.value.quantity != "" &&
        this.purchaseForm.value.quantity > 0
        ? this.purchaseForm.value.quantity
        : 1;

    this.qtyEntered = true;
  }

  checkStatus() {
    this.canUpdateStatus =
      !this.isCustomer && this.isStaff && !this.canApprove ? true : false;
  }

  setQuoteStatus() {
    this.selectedQuoteStatus = this.editQuoteForm.value.quote_status;
  }

  updateQuoteStatus() {
    this.editQuoteStatusModal.open();
  }

  updateQuote() {
    const payload: any = {
      quote_status:
        this.quote.quoteStatus == "new" ? "approved" : this.quote.quoteStatus,
    };

    this.store
      .select(updateQuoteSuccess)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((quote) => {
        if (quote) {
          this.toastrService.showSuccessToaster(
            "Success",
            "Quote updated",
            null
          );
          this.store.dispatch(new EmailPurchaseQuote(this.quote.id));
          const route = AppRoutes.PWA + AppRoutes.QUOTE_LIST;
          this.router.navigate([route]);
        }
      });

    this.store.dispatch(new UpdateQuote(payload, this.quote.id));
  }

  saveUpdateQuote() {
    if (this.selectedQuoteStatus) {
      const payload: any = {
        quote_status: this.selectedQuoteStatus,
      };

      this.store
        .select(updateQuoteSuccess)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((quote) => {
          if (quote) {
            this.toastrService.showSuccessToaster(
              "Success",
              "Quote updated",
              null
            );

            this.store.dispatch(new EmailPurchaseQuote(this.quote.id));
            this.editQuoteStatusModal.close();

            const route = AppRoutes.PWA + AppRoutes.QUOTE_LIST;
            this.router.navigate([route]);
          }
        });

      this.store.dispatch(new UpdateQuote(payload, this.quote.id));
    }
  }

  openRemoveUnitModal(purchaseLineItem) {
    this.selectedModalLineItemExtra = null;
    this.selectedModalLineItem = purchaseLineItem;
    this.removeUnitModal.open();
  }

  removeUnit() {
    const payload = {
      quote: null,
    };

    this.store.dispatch(
      new UpdatePurchaseLineItem(payload, this.selectedModalLineItem.id)
    );
  }

  saveUnit() {
    this.savingUnit = true;

    if (this.newUnit) {
      this.saveNewUnitConfig();
    } else {
      if (this.selectedUnit.name !== this.selectedFpProject.name) {
        // Existing unit's template option has changed. It's asset configuration will differ.
        const payload = { quote: null };
        this.recreatingExistingUnit = true;
        this.store.dispatch(
          new UpdatePurchaseLineItem(payload, this.selectedUnit.id)
        );
      } else {
        const payload = {
          name: this.selectedTemplateOption.name,
          unit: this.selectedTemplateOption.unit,
          description: this.selectedTemplateOption.description,
          template: true,
          drawing_no: this.selectedFpProject.drawingNumber,
          product_configurations: [],
          delivery_charge: this.quoteLineItem.transportOne ? this.quoteLineItem.transportOne.id : null,
          delivery_charge_qty: this.quoteLineItem.transportOne ? this.quoteLineItem.transportOne.quantity : null,
          delivery_charge_extra: this.quoteLineItem.transportTwo ? this.quoteLineItem.transportTwo.id : null,
          delivery_charge_extra_qty: this.quoteLineItem.transportTwo ? this.quoteLineItem.transportTwo.quantity : null,
          delivery_charge_optional: this.selectedFpProject.transportJoin
            ? this.selectedFpProject.transportJoin.id
            : null,
          delivery_charge_variation: this.selectedFpProject.transportExtra
            ? this.selectedFpProject.transportExtra.id
            : null,
          quantity: this.purchaseForm.value.quantity,
          quote: this.quote.id,
          floor_planner_sku: this.selectedTemplateOption.floorplannerProjectId,
          unit_size: this.selectedFpProject.size,
          unit_price: this.selectedFpProject.price,
          total_price: this.selectedFpProject.price * this.selectedFpProject.quantity,
          thumbnail: this.selectedTemplateOption.thumbnail,
          thumbnail_three_d: this.selectedTemplateOption.thumbnail3d,
        };

        this.store.dispatch(
          new UpdatePurchaseLineItem(payload, this.selectedUnit.id)
        );
      }
    }
  }

  saveNewUnitConfig() {
    let payload = {
      name: this.selectedTemplateOption.name,
      unit: "Unit " + (this.quote.purchaseLineItems.length + 1),
      description: this.selectedTemplateOption.description,
      template: true,
      drawing_no: this.selectedFpProject.drawingNumber,
      product_configurations: [],
      delivery_charge: this.quoteLineItem.transportOne ? this.quoteLineItem.transportOne.id : null,
      delivery_charge_qty: this.quoteLineItem.transportOne ? this.quoteLineItem.transportOne.quantity : null,
      delivery_charge_extra: this.quoteLineItem.transportTwo ? this.quoteLineItem.transportTwo.id : null,
      delivery_charge_extra_qty: this.quoteLineItem.transportTwo ? this.quoteLineItem.transportTwo.quantity : null,
      delivery_charge_optional: this.selectedFpProject.transportJoin
        ? this.selectedFpProject.transportJoin.id
        : null,
      delivery_charge_variation: this.selectedFpProject.transportExtra
        ? this.selectedFpProject.transportExtra.id
        : null,
      quantity: this.purchaseForm.value.quantity,
      quote: this.quote.id,
      floor_planner_sku: this.selectedTemplateOption.floorplannerProjectId,
      unit_size: this.selectedFpProject.size,
      unit_price: this.selectedFpProject.price,
      total_price: this.selectedFpProject.price * this.selectedFpProject.quantity,
      thumbnail: this.selectedTemplateOption.thumbnail,
      thumbnail_three_d: this.selectedTemplateOption.thumbnail3d,
    };

    this.store.dispatch(new CreatePurchaseLineItem(payload));
  }

  editLineItem(item) {
    this.preloadingEditForm = true;
    this.purchaseForm.reset();
    this.newUnit = false;
    this.editUnit = true;
    this.selectedUnit = item;
    this.modalTitle = "Edit Unit";
    this.addUnitModal.open();
    this.setEditFormWithLineItem();
  }

  setEditFormWithLineItem() {
    this.setEditCategory();
    this.purchaseForm.controls.quantity.setValue(this.selectedUnit.quantity);
    this.purchaseForm.markAllAsTouched();
    this.setUnitQty();
  }

  setEditCategory() {
    const category = this.fpProjectCategories.find((category) => {
      if (this.selectedUnit.name.includes(category.name)) return category;
    })

    this.purchaseForm.controls.project_category.setValue(category);
    this.setFpProjectCategory();
  }

  setEditSubCategory() {
    const category = this.fpProjectSubCategories.find((category) => {
      if (this.selectedUnit.name.includes(category.name)) return category;
    })

    this.purchaseForm.controls.project_sub_category.setValue(category);
    this.setFpProjectSubCategory();
  }

  setEditSize() {
    const size = this.fpProjectSizes.find((size) => {
      if (this.selectedUnit.name.includes(size.size)) return size;
    })

    this.purchaseForm.controls.project_size.setValue(size);

    this.setFpProjectSize();
  }

  setEditExtra() {
    const extra = this.fpProjectExtras.find((extra) => {
      if (this.selectedUnit.name.includes(extra.name)) return extra;
    })

    this.purchaseForm.controls.project_extra.setValue(extra);

    this.setFpProjectExtra();
  }

  setEditTemplateOption() {
    const project = this.projects.find((project) => {
      if (this.selectedUnit.name === project.name) return project;
    })

    this.purchaseForm.controls.template_option.setValue(project.floorplannerProjectId);

    this.setTemplateOption();

    if (this.quote.shipping) {
      this.setTruckSizeOptions();
    }
  }

  setTruckSizeOptions() {
    this.purchaseForm.controls.transport_load_one.setValue(this.selectedUnit.deliveryCharge.loadSize.id);
    this.purchaseForm.controls.transport_load_one_qty.setValue(this.selectedUnit.deliveryChargeQty);

    if (this.selectedUnit.deliveryChargeExtra) {
      this.addSecondTransportLoad = true;
      this.purchaseForm.controls.transport_load_two.setValue(this.selectedUnit.deliveryChargeExtra.loadSize.id);
      this.purchaseForm.controls.transport_load_two_qty.setValue(this.selectedUnit.deliveryChargeExtraQty);
    }
  }

  resetPurchaseForm() {
    this.purchaseForm.reset();
    this.resetEditState();
  }

  resetEditState() {
    this.editUnit = false;
    this.selectedUnit = null;
    this.hasProjectPricing = false;
    this.showProjectsTable = false;
    this.qtyEntered = false;
    this.showTemplateOption = false;
    this.selectedFpProjectCategory = false;
    this.selectedFpProjectSubCategory = false;
    this.selectedFpProjectSize = false;
    this.selectedFpProjectExtra = false;
    this.addSecondTransportLoad = false;
    this.projects = [];
    this.store.dispatch(new ClearProjectList());
  }

  registerSelectors() {
    this.store
      .select(getQuote)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((quote) => {
        if (quote) {
          this.quote = quote;
          this.quoteNumber = this.quote.quoteNumber;
          this.isSaProvince =
            this.quote.shippingProvince.name != "Other" ? true : false;
          this.canApprove = this.quote.quoteStatus == "new" ? true : false;
          if (this.quote.quoteStatus == "new") {
            this.canApprove = true;
          } else {
            this.canApprove = false;
          }
          this.checkStatus();
        }
      });

    this.store
      .select(getCurrentUser)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.user = res;
          this.isStaff = res.isStaff;
          this.isCustomer = !res.isStaff && res.customer != null ? true : false;
          this.isAdmin = res.isSuperuser;

          this.checkStatus();
        }
      });

    this.store
      .select(getFpProjectPriceList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((pricing: any) => {
        if (pricing) {
          if (pricing.length > 0) {
            this.selectedFpProject = {
              ...this.selectedFpProject,
              ...{
                price: this.addProjectPrice(pricing[0]),
                drawingNumber: pricing[0].drawingNumber,
              },
            };
            this.hasProjectPricing = true;
          }
        }
      });

    this.store
      .select(getProvinces)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((provinces: any) => {
        if (provinces && provinces.results) {
          this.provinces = provinces.results;
        }
      });

    this.store
      .select(getTransportPriceList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((transports: any) => {
        if (transports?.results?.length > 0) {
          if (
            this.transportType === "load1" &&
            (this.selectedTransportLoadOne !== null) &&
            this.selectedTransportLoadOne.results === null
          ) {
            this.filterTransportList("load1", transports.results, this.editingTransportLoad);
          } else if (
            this.transportType === "load2" &&
            (this.selectedTransportLoadTwo !== null) &&
            this.selectedTransportLoadTwo.results === null
          ) {
            this.filterTransportList("load2", transports.results, this.editingTransportLoad);
          }
        } else if (transports?.results?.length === 0) {

          if (this.transportType === "load1") {
            this.transportOneHasPricing = false;
            this.transportOneLoading = false;
          } else if (this.transportType === "load2") {
            this.transportTwoHasPricing = false;
            this.transportTwoLoading = false;
          }
        }
      });

    this.store
      .select(getCreatedLineItemsSuccess)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((item) => {
        if (item) {
          this.toastrService.showSuccessToaster(
            "Success",
            "Unit added",
            null
          );
          this.closeAddUnit();
        }
      });

    this.store
      .select(updatePurchaseLineItemSuccess)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((purchaseLineItem) => {
        if (!purchaseLineItem) return;

        if (!this.newUnit && !this.editUnit) {
          this.toastrService.showSuccessToaster(
            "Success",
            "Unit removed",
            null
          );
          this.removeUnitModal.close();
          this.initialDispatches();
        }
        else if (this.editUnit && !this.recreatingExistingUnit) {

          this.toastrService.showSuccessToaster(
            "Success",
            `Unit updated`,
            null
          );
          this.addUnitModal.close();
          this.resetUnitForm();
          this.initialDispatches();
        }
        else if (this.editUnit && this.recreatingExistingUnit) {
          this.saveNewUnitConfig();
        }
      });

    this.store
      .select(getCreatedPurchaseLineItems)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((items) => {
        if (items && items.length > 0) {
          this.addedLineItem = items[0];

          if (this.quoteLineItemProducts.length == 0) {
            this.addUnitModal.close();
            this.resetUnitForm();
            this.initialDispatches();
            this.addedLineItem = null;
          } else {
            this.saveProducts();
          }
        }
      });

    this.store
      .select(getCreatedLineItemConfigs)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((products) => {
        if (products && products.length > 0) {
          let productsAdded = products.length;

          if (this.quoteLineItemProducts.length == productsAdded) {
            this.addUnitModal.close();
            this.resetUnitForm();
            this.initialDispatches();
          } else {
            if (productsAdded > 0) {
              let itemIdx = this.quoteLineItemProducts[productsAdded];
              this.saveProduct(itemIdx);
            }
          }
        }
      });

    this.store
      .select(getFpProjectCategoryList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((categories) => {
        if (categories) {
          this.fpProjectCategories = categories.filter(
            (item) => item.name !== "Shell"
          );
        }
      });

    this.store
      .select(getFpProjectSubCategoryList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((sub_cats) => {
        if (sub_cats && sub_cats.length > 0) {
          let sub_categories = [];

          sub_cats.forEach((cat) => {
            let sub_cat = cat.subCategory;
            sub_categories.push(sub_cat);
          });

          this.fpProjectSubCategories = sub_categories.filter(
            (sub_cat, index) => {
              return sub_categories.indexOf(sub_cat) === index;
            }
          );

          this.fpProjectSubCategories = sub_categories.filter(
            (v, i) =>
              sub_categories.findIndex((item) => item.name == v.name) === i
          );

          if (this.editUnit) {
            this.setEditSubCategory();
          }
        }
      });

    this.store
      .select(getFpProjectSizeList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((cat_sizes) => {
        if (cat_sizes && cat_sizes.length > 0) {
          let sizes = [];

          cat_sizes.forEach((size) => {
            let sub_cat = size.size;
            sizes.push(sub_cat);
          });

          this.fpProjectSizes = sizes.filter((sub_cat, index) => {
            return sizes.indexOf(sub_cat) === index;
          });

          if (this.editUnit) {
            this.setEditSize();
          }
        }
      });

    this.store
      .select(getFpProjectExtrasList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((variations) => {
        if (variations && variations.length > 0) {
          this.fpProjectExtras = variations;

          if (this.editUnit) {
            this.setEditExtra();
          }
        }
      });

    this.store
      .select(getFpProjectList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((projects: any) => {
        if (projects?.results?.length > 0) {
          this.projects = projects.results;
          this.showProjectsTable = true;

          if (this.editUnit) {
            this.setEditTemplateOption();
            this.preloadingEditForm = false;
          }
        } else {
          this.projects = [];
          this.showProjectsTable = true;
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.cancelationSubscription.unsubscribe();
  }
}

// TODO: When editing a unit, prepopulate all relevant fields